module.exports = __webpack_public_path__ + "static/media/tickets-menu-item.b08d9c8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tickets-menu-item.svg
// module id = 178
// module chunks = 0